"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _AppContext = require("./context/AppContext");

var _utils = require("../utils");

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/App.css") : void 0;
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("../listings/style/slick-carousel.css") : void 0;

var _userProfileModule = require("../userProfile/userProfileModule");

var _utilsModule = require("../utils/utilsModule");

var _listingsModule = require("../listings/listingsModule");

var _listingModule = require("../listing/listingModule");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var urlToLang = function urlToLang(url) {
  return (0, _utils.mapCountryToPublicLang)((0, _utils.getCountryCode)(url));
};

var App =
/*#__PURE__*/
function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).call(this, props));
    props.isAppCenterEnabledCheck();
    props.setIsPublic((0, _utils.isPublic)(props.location.pathname));
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _utils.canUseDOM)() && (0, _utils.isPublic)(this.props.location.pathname)) {
        if (window.utag_data) {
          window.site_regional = urlToLang(this.props.meta.originalhost);
        }
      }

      this.loadTrustArcScript();
    }
  }, {
    key: "loadTrustArcScript",
    value: function loadTrustArcScript() {
      var script = document.createElement('script');
      script.src = '//consent.trustarc.com/notice?domain=concur.com&c=teconsent&js=nj&noticeType=bb&text=true';
      script.async = true;
      var footerElement = document.getElementById('teconsent');
      footerElement.appendChild(script);
      this.props.fetchListingsIfNeeded();
      this.props.fetchLocalizedRegions();
      this.props.fetchLocalizedCountries();
      this.props.fetchCategoriesIfNeeded();
    }
  }, {
    key: "render",
    value: function render() {
      var style = {};
      var scripts = [];
      var title = 'App Center';
      var links = [{
        href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.3.15/slick.css',
        rel: 'stylesheet',
        type: 'text/css'
      }]; // TODO: figure out why the details page won't update canonical, then re-enable

      if ((0, _utils.isPublic)(this.props.location.pathname)) {
        title = 'SAP Concur App Center';
        style.backgroundColor = '#efefef';
        scripts = [{
          src: '//code.jquery.com/jquery-1.12.4.min.js',
          type: 'text/javascript'
        }];

        function getCookie(name) {
          var re = new RegExp("".concat(name, "=([^;]+)"));
          var value = re.exec(document.cookie);
          return value != null ? unescape(value[1]) : null;
        }

        if ((0, _utils.canUseDOM)()) {
          if (typeof getCookie('notice_preferences') === 'undefined' || getCookie('notice_preferences') == null || getCookie('notice_preferences') !== '0:') {
            scripts.push({
              src: '//static.concursolutions.com/nui/appcenter/static/omniture.bundle.f4e88b342e6ff25c6df3.js',
              type: 'text/javascript'
            });
          }
        }

        if (this.props.meta.originalhost) {
          links.push({
            rel: 'canonical',
            href: "".concat((0, _utils.getCanonicalLink)(this.props.meta.originalhost, this.props.location.pathname))
          });
        }

        links.push({
          rel: 'shortcut icon',
          href: '//www.concur.com/sites/all/themes/concur7/favicon.ico',
          type: 'image/png'
        });
        (0, _utils.getHreflangLinks)(links);
      }

      var context = {
        userProfile: this.props.userProfile,
        isPublic: (0, _utils.isPublic)(this.props.location.pathname),
        getTitle: function getTitle(newTitle) {
          if (newTitle !== _utils.HOME) {
            return "".concat(newTitle, " - ").concat(title);
          }

          return title;
        }
      };
      return _react.default.createElement("div", {
        id: "app",
        style: style
      }, _react.default.createElement(_AppContext.AppContext.Provider, {
        value: context
      }, _react.default.createElement(_reactHelmet.default, {
        htmlAttributes: {
          lang: (0, _utils.getNuiLanguage)(this.props.meta.originalhost)
        },
        title: title,
        meta: [{
          'char-set': 'utf-8'
        }, {
          name: 'application-name',
          content: this.props.formatter.formattedMessage({
            id: 'AppCenterHeader'
          })
        }, {
          name: 'description',
          content: this.props.formatter.formattedMessage({
            id: 'MetaDescription'
          })
        }, {
          name: 'keywords',
          content: 'Concur App Center, App Center'
        }, {
          name: 'viewport',
          content: 'width=device-width,initial-scale=1'
        }],
        script: scripts,
        link: links
      }), _react.default.createElement("div", {
        className: "route-content ".concat((0, _utils.isPublic)(this.props.location.pathname) ? 'public-content container' : ''),
        style: {
          fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
        }
      }, this.props.children)));
    }
  }]);

  return App;
}(_react.Component); // We don't own location, formatter, or userProfile so we shouldn't define the shape.
// Ideally the react-router and nui-intl packages would expose the shape and we could consume it.


App.propTypes = {
  children: _propTypes.default.node,
  isAppCenterEnabledCheck: _propTypes.default.func.isRequired,
  setIsPublic: _propTypes.default.func.isRequired,
  meta: _propTypes.default.shape({
    originalhost: _propTypes.default.string
  }),
  userProfile: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  formatter: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userProfile: state.userProfile,
    meta: state.meta
  };
};

var mapDispatchToProps = {
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck,
  setIsPublic: _utilsModule.setIsPublic,
  fetchListingsIfNeeded: _listingsModule.fetchListingsIfNeeded,
  fetchLocalizedRegions: _listingModule.fetchLocalizedRegions,
  fetchLocalizedCountries: _listingModule.fetchLocalizedCountries,
  fetchCategoriesIfNeeded: _listingsModule.fetchCategoriesIfNeeded
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _nuiIntl.withFormatter)(App));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/app/App.js
// module id = 236
// module chunks = 0